export function satelliteInfoUrl(object) {
  const name = String(object?.name || "").trim();
  const noradId = Number(object?.noradId);
  const terms = [name];
  if (Number.isInteger(noradId) && noradId > 0) terms.push(`NORAD ${noradId}`);
  const url = new URL("https://duckduckgo.com/");
  url.searchParams.set("q", terms.filter(Boolean).join(" "));
  return url.toString();
}
